// extracted by mini-css-extract-plugin
export default {"errorsList":"ErrorsAlert_errorsList__VOUo7","wrapper":"ErrorsAlert_wrapper__G7L0C","property":"ErrorsAlert_property__s4xzK"};